const apiConfig = {
 //production
  apiBaseURL: "https://1j16lm583j.execute-api.us-east-1.amazonaws.com/prod",
  'x-api-key': "phu5bU3B8H2BZpNgtabJ727cHZahc2u1674e19mk",

  //prod admin Api Url
  apiBaseURL2: "https://npd5c7f9zi.execute-api.us-east-1.amazonaws.com/prod",
  'x-api-key2': "BxMwfNBMxb5fe5RBs3IS2319tzMbVPOT8TwW4zGX",


  //dev
  // apiBaseURL: "https://1j16lm583j.execute-api.us-east-1.amazonaws.com/prod",
  // 'x-api-key': "RFimftFBkW3REVld6DKRd2fjsE8gDDIs1DrvsvQc",

  //admin Api Url
  // apiBaseURL2: "https://npd5c7f9zi.execute-api.us-east-1.amazonaws.com/prod",
  // 'x-api-key2': "BxMwfNBMxb5fe5RBs3IS2319tzMbVPOT8TwW4zGX",

  //Local Api Url
  // apiBaseURL: "http://localhost:9000/dev",
  // 'x-api-key':"htWF7PGdFM5LkaDgicici4M7z54nkkom13okXB4U" 

};

export default apiConfig;
